import React, { Suspense, lazy } from 'react';
import { Redirect, Switch, Route } from 'react-router-dom';
import { LayoutSplashScreen } from '../_metronic/layout';

const PosPage = lazy(() =>
	import('./modules/ECommerce/pages/PosPage')
);

export default function BasePage() {
	return (
		<Suspense fallback={<LayoutSplashScreen />}>
			<Switch>
				<Redirect exact from='/' to='/pos/bills' />
				<Route path='/pos' component={PosPage} />
				<Redirect to='/pos/bills' />
			</Switch>
		</Suspense>
	);
}
